"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var dateUtils = _interopRequireWildcard(require("../../utils/date"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LastUpdatedDateIcon = function LastUpdatedDateIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14.496a7.001 7.001 0 0 0 0-14 7.001 7.001 0 0 0 0 14Zm0-1.488a5.51 5.51 0 1 0 .002-11.021A5.51 5.51 0 0 0 7 13.007Z",
    fill: "#58595A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.498 8.234V3.957h1.07v3.65l3.146 1.95-.63.88-3.586-2.203Z",
    fill: "#58595A"
  }));
};
LastUpdatedDateIcon.defaultProps = {
  viewBox: "0 0 14 15",
  xmlns: "http://www.w3.org/2000/svg"
};
var styles = {
  "icon": "AssetModifiedDate__icon__38XWV",
  "metadata-item": "AssetModifiedDate__metadata-item__1MqEK",
  "metadataItem": "AssetModifiedDate__metadata-item__1MqEK",
  "metadata-item-wrapper": "AssetModifiedDate__metadata-item-wrapper__2wxp-",
  "metadataItemWrapper": "AssetModifiedDate__metadata-item-wrapper__2wxp-"
}; 
require('./AssetModifiedDate.css');
var AssetModifiedDate = function AssetModifiedDate(_ref) {
  var minorVersionModifiedAt = _ref.minorVersionModifiedAt;
  var format = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.metadataItemWrapper,
    title: "Last modified date",
    "data-test-id": "last-modified-at"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon,
    "data-test-id": "last-modified-at-icon",
    "aria-hidden": true
  }, /*#__PURE__*/_react.default.createElement(LastUpdatedDateIcon, null)), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: dateUtils.formatDate(minorVersionModifiedAt, format)
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "last-modified-at-content",
    className: styles.metadataItem
  }, "Updated ", dateUtils.formatRelativeDate(minorVersionModifiedAt))));
};
var _default = exports.default = AssetModifiedDate;
//# sourceMappingURL=AssetModifiedDate.js.map